import { normalizeError } from '@packages/shared/core/common/utils/errors';
import { AppThunk } from '@packages/shared/core/common/store';
import { OrganicChannelAttributionStrategy } from '@packages/shared/core/common/services/channelAttribution';
import { isOrganicChannel } from '@packages/shared/core/common/utils/channel/isOrganicChannel';
import { userUtmTagsUpdated } from './actions';

export const markUtmSourceForIncomingUser = (): AppThunk => async (dispatch, getState, services) => {
  const { utmTagsService, analyticsService, logger, channelAttributionService, cookiesService } = services;
  const cookiesEnabled = cookiesService.isEnabled();

  if (!cookiesEnabled) return;

  const isUtmSourceAlreadyExist = !!utmTagsService.getUtmSource();

  if (isUtmSourceAlreadyExist) return;

  try {
    const referrer = document.referrer;
    const isOrganicUser = isOrganicChannel(referrer);

    if (isOrganicUser) {
      channelAttributionService.setAttributionStrategy(new OrganicChannelAttributionStrategy(referrer));
    }

    const utmTags = channelAttributionService.getUtmTags();

    const updatedUtmTags = utmTagsService.updateUtmTags(utmTags);
    await analyticsService.updateUtmTags(updatedUtmTags);

    dispatch(userUtmTagsUpdated(updatedUtmTags));
  } catch (err) {
    const error = normalizeError(err);

    logger.error(error);
  }
};
